(function ($) {
	$.progressBar = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			ProgressBar = (function ($c, o) {
				var defaults = {
					bar: '.bar',

					onProgress: null,
					onUploadProgress: null,
					onComplete: null
				}; 

				var _o = {},
					pl = 0, // Percent Loaded

					tl = null, // Timeline

					$bar = null // Progress Bar
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$bar = $(_o.bar, $c);
					_BuildTimeline();
				},

					_BuildTimeline = function() {
						tl = new TimelineMax({ paused: true, useFrames: true });
						tl.add(new TweenLite($bar, 100, { css: { xPercent: 100 }, ease: Expo.easeInOut }));
					},

					_OnXhr = function(e) {
						var xhr = (window.ActiveXObject) ? new window.ActiveXObject('Microsoft.XMLHTTP') : new window.XMLHttpRequest();
						xhr.addEventListener("progress", _OnLoadProgress, false);
						xhr.upload.addEventListener("progress", _OnProgress, false);

						return xhr;              
					},

						_OnUploadProgress = function(e) {
							_OnProgress(e);
							if (_o.onUploadProgress) {
								_o.onUploadProgress(e);
							}
						},

						_OnLoadProgress = function(e) {
							_OnProgress(e);
							if (_o.onProgress) {
								_o.onProgress(e);
							}
						},

						_OnProgress = function(e) {
							if (e.lengthComputable) {
								_HandleProgress(e.loaded / e.total);
							} else {
								// Move at 10% increments
								var pc = pl + 10;
								if (pc > 100) { pc = 100; }

								_HandleProgress(pc);
							}
						},

							_HandleProgress = function(inc) {
								pl = Math.round(inc);
								tl.tweenTo(pl);
							},

					_OnXhrDone = function(e) {
						if (_o.onComplete) {
							_HandleProgress(100);
							_o.onComplete(e);
						}
					},


				_BindEvents = function () {
					$.ajax({
						url: window.location.href,
						xhr: _OnXhr,
					}).done(_OnXhrDone);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.progressBar = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('progressBar')) {
				var plugin = new $.progressBar(this, options);
				$(this).data('progressBar', plugin);
			}
		});
	};
})(jQuery);
